import React, { useState, useEffect, useRef } from "react";
import Leaderboard from '@mui/icons-material/Leaderboard';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import CircleIcon from "@mui/icons-material/Circle";
import CircularProgress from '@mui/material/CircularProgress';
import PopUsageList from './pop-usage-list';
import PopLinkTutor from './pop-link-tutor';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CheckCircle, Delete, Block } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import AppTopBar2 from "./common/app-top-bar2";
import AppLoading from "./common/app-loading";
import PopAccessRights from "./pop-access-rights";
import VisibilityIcon from '@mui/icons-material/Visibility';
import PopInviteEmail from './pop-invite-email';
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import PopReportCard from '../components/report-card/pop-report-card';
import {
  Button,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  Switch,
  Divider,
  TablePagination,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Select,
  Typography,
  MenuItem,
  TextField,
  Tooltip,
  Grid,
  Snackbar, 
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  TableSortLabel,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { AppHelper } from "../AppHelper";
import { EssayHelper } from "../helpers/essay.helper";
import EssayView from "./essay/essay-view";
import SpaCheck from "./common/spa-check";
import EditIcon from '@mui/icons-material/Edit';
const dayjs = require("dayjs");

function descendingComparator(a, b, orderBy) {
	
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
	
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function stableSortProfile(array, comparator) {
  const stabilizedThis = array.filter((x)=>x.type=="Account").map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsProfile = [
  { id: "i", numeric: false, disablePadding: false, label: "" },
  { id: "name", numeric: false, disablePadding: false, label: "NAME" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },
  { id: "essayCount", numeric: true, disablePadding: false, label: "ESSAYS" },
  {
    id: "createdDate",
    numeric: false,
    disablePadding: false,
    label: "CREATED ON",
  },
  {
    id: "lastLogin",
    numeric: false,
    disablePadding: false,
    label: "LAST LOGIN",
  },
  {
    id: "accountType",
    numeric: false,
    disablePadding: false,
    label: "ACCOUNT TYPE",
  },
  { id: "status", numeric: false, disablePadding: false, label: "STATUS" },
  { id: "action", numeric: true, disablePadding: false, label: "ACTION" },
];

const headCellsAcc = [
  { id: "i", numeric: false, disablePadding: false, label: "" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },
  { id: "accountType", numeric: false, disablePadding: false, label: "ACCOUNT TYPE" },
  {
    id: "totalProfiles",
    numeric: true,
    disablePadding: false,
    label: "PROFILES",
  },
  { id: "totalEssays", numeric: true, disablePadding: false, label: "ESSAYS" },
  { id: "status", numeric: true, disablePadding: false, label: "STATUS" },
  {
    id: "tCodeCreatedOn",
    numeric: true,
    disablePadding: false,
    label: "CREATED ON",
  },
  {
    id: "tCodeLastLogin",
    numeric: true,
    disablePadding: false,
    label: "LAST LOGIN",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "ACTION",
  },
];

const headCellsTui = [
  { id: "i", numeric: false, disablePadding: false, label: "" },
  { id: "name", numeric: false, disablePadding: false, label: "NAME" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },

  { id: "status", numeric: false, disablePadding: false, label: "STATUS" },
  { id: "access", numeric: false, disablePadding: false, label: "ACCESS RIGHT" },
  {
    id: "tCodeCreatedOn",
    numeric: false,
    disablePadding: false,
    label: "CREATED ON",
  },
  {
    id: "tCodeLastLogin",
    numeric: false,
    disablePadding: false,
    label: "LAST LOGIN",
  },
  { id: "link", numeric: false, disablePadding: false, label: "" },
];

const headCellsTut = [
  { id: "i", numeric: false, disablePadding: false, label: "" },
  { id: "name", numeric: false, disablePadding: false, label: "NAME" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },
  { id: "tuition_center", numeric: false, disablePadding: false, label: "TUITION CENTER" },
  { id: "status", numeric: true, disablePadding: false, label: "STATUS" },
  {
    id: "tCodeCreatedOn",
    numeric: true,
    disablePadding: false,
    label: "CREATED ON",
  },
  {
    id: "tCodeLastLogin",
    numeric: true,
    disablePadding: false,
    label: "LAST LOGIN",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells =
    props.gid == "A1"
      ? headCellsAcc
        : props.gid == "T1"
          ? headCellsTui
            : props.gid == "R1"
              ? headCellsTut
              : headCellsProfile;

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageSaEssayListV2() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();

  const [isLoading, setIsLoading] = useState(true);
  const [essayList, setEssayList] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const [originalProfileList, setOriginalProfileList] = useState([]);

  const [accList, setAccList] = useState([]);
  const [originalAccList, setOriginalAccList] = useState([]);
  const [tuiList, setTuiList] = useState([]);
  const [acceptedTutorList, setAcceptedTutorList] = useState([]);
  const [invitedTutorList, setInvitedTutorList] = useState([]);
  const [originalTuiList, setOriginalTuiList] = useState([]);

  const [tutList, setTutList] = useState([]);
  const [originalTutList, setOriginalTutList] = useState([]);

  const [feedbackList, setFeedbackList] = useState([]);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [viewMode, setViewMode] = React.useState("CARDS");
  const [refreshList, setRefreshList] = React.useState(false);
  const [recEssay, setRecEssay] = React.useState({});
  const [countEssay, setCountEssay] = React.useState(null);
  const [countExercise, setCountExercise] = React.useState(null);
  const [countUser, setCountUser] = React.useState(null);
  const [countAcc, setCountAcc] = React.useState(null);
  const [countTui, setCountTui] = React.useState(null);
  const [countTut, setCountTut] = React.useState(null);
  const [countFeedback, setCountFeedback] = React.useState(null);

  const [tuiton, setTuiton] = React.useState("");

  const [tblOrderProfile, setTblOrderProfile] = React.useState("desc");
  const [tblOrderByProfile, setTblOrderByProfile] =
    React.useState("essayCount");
  const [filterProfile, setFilterProfile] = React.useState("");

  const [tblOrderAcc, setTblOrderAcc] = React.useState("desc");
  const [tblOrderByAcc, setTblOrderByAcc] = React.useState("totalProfiles");
  const [filterAcc, setFilterAcc] = React.useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [recProfile, setRecProfile] = useState({});

  const [tblOrderTui, setTblOrderTui] = React.useState("desc");
  const [tblOrderByTui, setTblOrderByTui] = React.useState("totalProfiles");
  const [filterTui, setFilterTui] = React.useState("");

  const [tblOrderTut, setTblOrderTut] = React.useState("desc");
  const [tblOrderByTut, setTblOrderByTut] = React.useState("totalProfiles");
  const [filterTut, setFilterTut] = React.useState("");

  const [enhancedTransription, setEnhancedTransription] = useState(0);
  
  const handleReportCard = (row) => {    
    setSelectedProfileId (row.profileId);
	setSelectedProfileName (row.name);
    setIsPopReportCardOpen(!isPopReportCardOpen);
  };
  
  const handleUnlinkTutor = async (row) => {        
	if(window.confirm("Are you sure to unlink this profile?")){
		setRefreshList(false);
		var _res = await AppHelper.apiPost('api/profile/tutor/link', { token: oUser.token, profileId: row.profileId });
		if (!_res || !_res.status) {
		  setIsLoading(false);
		  return;
		}
		alert("Unlink success");

    // Refresh page
		fetchTuiList();
    fetchTutList();
	}
  };
  
  const handleLinkTutor = async (row) => {    
    setTuiton(row.profileId);
	  setIsPopLinkTutorOpen(true);
  };
  
  const popLinkTutorClose = (refresh) => {
    if (refresh) {
      fetchTuiList();
      fetchTutList();
    }
    setIsPopLinkTutorOpen(false);
  }

  const handleViewUsageClick = (row) => {
    setSelectedAccount(row.accountId);
    setIsPopUsageOpen(!isPopUsageOpen);
  };

  const popUsageListClose = (questionId) => {
    setIsPopUsageOpen(false);
  }

  const onPopAccessRights = (arg)=>{
    setPopAccessRightsOpen(true);
    setRecProfile(arg);
  }
  const popAccessRightsClose = ()=>{
    setPopAccessRightsOpen(false);
  }
  
  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  useEffect(() => {
    fetchConfig();
  }, []);

  const toggleCollapse = (row) => {
    setProfileList((prevProfiles) =>
      prevProfiles.map((profile) =>
        profile.profileId === row.profileId || row.accountId == profile.accountId
          ? { ...profile, isExpanded: !profile.isExpanded }
          : profile
      )
    );
  };
  
  const toggleCollapseTui = async (row) => {

    setTuiList((prevProfiles) =>
      prevProfiles.map((profile) =>
        profile.centerId === row.profileId
          ? { ...profile, isExpanded: !profile.isExpanded }
          : profile
      )
    );
    row.isExpanded = !row.isExpanded
  };

  const fetchConfig = async () => {
    setIsLoading(true);
    var _res = await AppHelper.apiPost('api/setting/list', { token: oUser.token });
    if (!_res || !_res.status) {
      setIsLoading(false);
      return;
    }
    var enhancedTransription = _res.data.filter((k) => k.code == 'enhanced.transcription')[0];

    if (enhancedTransription) {
      setEnhancedTransription(parseInt(enhancedTransription.value));
    }
    else {
      setEnhancedTransription(1);
    }
    setRefreshList(false);
  };

  const handleEnhancedTransriptionChange = async () => {
    const newState = enhancedTransription == 0 ? 1 : 0;
    setEnhancedTransription(newState);

    var _res = await AppHelper.apiPost("api/setting/update", {
      token: oUser.token,
      code: 'enhanced.transcription',
      value: newState,
    });
  };

  useEffect(() => {
    if (!oUser) {
      navigate("/login");
      return;
    }
  });

  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(dayjs());

  const [isIncludeDeletedUser, setIsIncludeDeletedUser] = useState(false);
  const [isIncludeDeletedAcc, setIsIncludeDeletedAcc] = useState(false);
  const [isIncludeDeletedTui, setIsIncludeDeletedTui] = useState(false);
  const [isIncludeDeletedTut, setIsIncludeDeletedTut] = useState(false);
  const [popInviteEmailOpen, setPopInviteEmailOpen] = useState(false);
  const [isPopUsageOpen, setIsPopUsageOpen] = useState(false);
  const [isPopLinkTutorOpen, setIsPopLinkTutorOpen] = useState(false);
  const [isPopReportCardOpen, setIsPopReportCardOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedProfileId, setSelectedProfileId] = useState("");
  const [selectedProfileName, setSelectedProfileName] = useState("");
  const [popAccessRightsOpen, setPopAccessRightsOpen] = useState(false);

  useEffect(() => {
    var _list = originalProfileList.filter(
      (x) => (x.status == 1 || isIncludeDeletedUser)
    );
    setProfileList(_list);
    if (countUser != null) {
      setCountUser(originalProfileList.filter(
        (x) => x.type == "Profile" && (x.status == 1 || isIncludeDeletedUser)
      ).length);
    }
  }, [isIncludeDeletedUser]); // Run this effect whenever isIncludeDeletedUser changes

  useEffect(() => {
    var _list = originalAccList.filter(
      (x) => x.status == 1 || isIncludeDeletedAcc
    );
    setAccList(_list);
    if (countAcc != null) {
      setCountAcc(_list.length);
    }
  }, [isIncludeDeletedAcc]); // Run this effect whenever isIncludeDeletedUser changes

  useEffect(() => {
    var _list = originalTuiList.filter(
      (x) => x.status == 1 || isIncludeDeletedTui
    );
    setTuiList(_list);
    if (countTui != null) { //to prevent the number showed as 0 before tuilist was loaded. 
      setCountTui(_list.length);
    }
  }, [isIncludeDeletedTui]);

  useEffect(() => {
    var _list = originalTutList.filter(
      (x) => x.status == 1 || isIncludeDeletedTui
    );
    setTutList(_list);
    if (countTui != null) {
      setCountTut(_list.length);
    }
  }, [isIncludeDeletedTut]);

  const handleIncludeDeletedUser = (event) => {
    setIsIncludeDeletedUser(!isIncludeDeletedUser);
  };

  const handleIncludeDeletedAcc = (event) => {
    setIsIncludeDeletedAcc(!isIncludeDeletedAcc);
  };
  const handleIncludeDeletedTui = (event) => {
    setIsIncludeDeletedTui(!isIncludeDeletedTui);
  };

  const handleIncludeDeletedTut = (event) => {
    setIsIncludeDeletedTut(!isIncludeDeletedTut);
  };

  const handleAccountTypeChange = async (event, id, {useProfileId= true} = {}, email) => {
    const newAccountType = event.target.value;
    if (
      window.confirm(
        "Are you sure you want to update the profile as " +
        (newAccountType == "PAR"
          ? "Parent"
          : newAccountType == "STU"
            ? "Student"
            : newAccountType == "TUI"
              ? "Tuition Center"
              : newAccountType == "TEA"
                ? "Tutor"
              : "Parent")
      )
    ) {
      var _res = await AppHelper.apiPost("api/account/updateAccountType", {
        isSA: 1,
        token: oUser.token,
        accountType: newAccountType,
        ...( useProfileId ? { profileId: id} : {accountId: id}), 
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      } else {
        if (_res && _res.status) {
          var updatedList =[];
          if (useProfileId) {
            updatedList = profileList.map((profile) => {
              if (profile.profileId === id) {
                return { ...profile, accountType: newAccountType };
              }
              return profile;
            });
            setProfileList(updatedList);
          } else {
            updatedList = accList.map((account) => {
              if (account.accountId === id) {
                return { ...account, accountType: newAccountType };
              }
              return account;
            });
            setAccList(updatedList);
          }
          if (email == oUser.email) {
            oUser.accountType =  newAccountType;
            AppHelper.userCacheUpdate(oUser);
          }
          // Update state or props with the updatedProfiles
          // alert("Account type updated successfully");
          setOpenSnackBar(true);
        }
      }
    }
  };

  const handleSnackBarClose = () => {
    setOpenSnackBar(false);
  }

  const fetchProfileList = async (argEssays) => {
    essayList.splice(0);
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/account/list/sa", {
      token: oUser.token,
    });
    setIsLoading(false);
    if (!_res || !_res.status) {
      return;
    }
    var idx = 1;
    _res.data.forEach((r, i) => {
      var _ts = dayjs(r.createdOn);
      if (r.type == "Account") {
        r.i = idx++;
      }

      r.tCode = _ts.format("YYYYMMDDHHmmss");
      r.tTitle = `` + _ts.format(`DD MMM 'YY HH:mm`);

      if (r.type == "Profile") {
        r.essays = argEssays.filter((e) => e.profileId == r.profileId);
        r.essayCount = r.essays.length;
      }

      r.createdDate = _ts.toDate();
      r.tTitle = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` + _ts.format('DD MMM YYYY');

      if(!r.lastLogin) r.lTitle = '-';
      else{
        _ts = dayjs(r.lastLogin);
        r.lTitle = _ts.format(`DD MMM 'YY HH:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` + _ts.format('DD MMM YYYY');
      }

      r.isExpanded = false;
    });

    var _list = _res.data;// [...AppHelper.sortList(_res.data, "", 2)];
    setOriginalProfileList(_list);

    if (!isIncludeDeletedUser) {
      _res.data = _res.data.filter((x) => x.status == 1);
    }
    _list = _list.filter((x) => x.accountType != 'TUI');
    _list = _res.data; // [...AppHelper.sortList(_res.data, "", 2)];
    setProfileList(_list);
  };

  const fetchAccList = async () => {
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/account/list/sa/v1", {
      token: oUser.token,
    });
    if (!_res || !_res.status) {
      return;
    }	  
    _res.data.forEach((r, i) => {
      r.i = i;
      if (r.lastLogin) {
        var _ts = dayjs(r.lastLogin);
        r.lastLogin = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeLastLogin = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.lastLogin = "";
        r.tCodeLastLogin = "";
      }

      if (r.createdOn) {
        var _ts = dayjs(r.createdOn);
        r.createdOn = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeCreatedOn = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.createdOn = "";
        r.tCodeCreatedOn = "";
      }
    });

    var _list = [...AppHelper.sortList(_res.data, "totalProfiles", 2)];
    setOriginalAccList(_list);

    if (!isIncludeDeletedAcc) {
      _res.data = _res.data.filter((x) => x.status == 1);
    }
    _list = [...AppHelper.sortList(_res.data, "totalProfiles", 2)];
    setAccList(_list);

    setIsLoading(false);
  };

  const fetchTuiList = async () => {
    setIsLoading(true);
 
    var _res = await AppHelper.apiPost("api/account/list/type/tuition", {
      token: oUser.token,
    });
    if (!_res || !_res.status) {
      return;
    }

    var _list = [...AppHelper.sortList(_res.data, "totalProfiles", 2)];
    setOriginalTuiList(_list);

    if (!isIncludeDeletedTui) {
      _res.data = _res.data.filter((x) => x.status == 1);
    }

    _list = [...AppHelper.sortList(_res.data, "totalProfiles", 2)];

    const acceptedTutorList = await fetchAcceptedTutorList();
    setAcceptedTutorList(acceptedTutorList);
    const invitedTutorList = await fetchInvitedTutorList();
    setInvitedTutorList(invitedTutorList);

    for (let i = 0; i < _list.length; i++) {
      const item = _list[i];
      acceptedTutorList.forEach((aTutor) => {
        if (item.profileId === aTutor.centerId) {
          aTutor.accepted = true;
          _list.splice(i + 1, 0, aTutor);
          i++;
        }
      });
    }
    
    for (let i = 0; i < _list.length; i++) {
      const item = _list[i];
      invitedTutorList.forEach((invTutor) => {
        if (item.profileId === invTutor.centerId &&
            !_list.some(aTutor => aTutor.email.toLowerCase() === invTutor.email.toLowerCase())) {
          invTutor.accepted = false;
          _list.splice(i + 1, 0, invTutor);
          i++;
        }
      });
    }
    
    _list.forEach((item) => { 
      if (item.accountType === "TUI") { 
        item.teaCount = _list.filter((x) => 
          x.accountType !== "TUI" && x.centerId === item.profileId ).length; 
      } 
    });

    _list.forEach((r, i) => {
      r.i = i;
      if (r.lastLogin) {
        var _ts = dayjs(r.lastLogin);
        r.lastLogin = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeLastLogin = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.lastLogin = "";
        r.tCodeLastLogin = "";
      }

      if (r.createdOn) {
        var _ts = dayjs(r.createdOn);
        r.createdOn = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeCreatedOn = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.createdOn = "";
        r.tCodeCreatedOn = "";
      }
    });

    var _resAccess = await AppHelper.apiPost("api/access/all", {
      token: oUser.token,
    });
    var _gradeList=[
      {v:'P1', a:0}, {v:'P2', a:0}, {v:'P3', a:0},
      {v:'P4', a:0}, {v:'P5', a:0}, {v:'P6', a:0},
      {v:'S1', a:0}, {v:'S2', a:0}, {v:'S3', a:0},
      {v:'S4', a:0}, {v:'S4E', a:0}, {v:'S5', a:0},
    ];
    var _accessAll = (_resAccess && _resAccess.status && _resAccess.data) ? _resAccess.data : [];
    for(var i=0;i<_list.length; i++){
      var _recTutor = _list[i];
      var _accessArr = _accessAll.filter(r=>r.profileId==_recTutor.profileId);
      _recTutor.access = _gradeList.map(g => ({ ...g }));//[..._gradeList];
      _recTutor.access.forEach(a=>{
        var _access = _accessArr.find(r=>r.grade == a.v);
        if(_access) a.a = _access.access;
      });
    }
    setTuiList(_list);
    setCountTui(_list.filter((x) => x.accountType == 'TUI' && x.type == "Account").length);
    
    fetchTutList();
  };

  const fetchTutList = async () => {
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/account/list/sa/", {
      token: oUser.token,
    });
    if (!_res || !_res.status) {
      return;
    }
    _res.data.forEach((r, i) => {
      r.i = i;
      if (r.lastLogin) {
        var _ts = dayjs(r.lastLogin);
        r.lastLogin = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeLastLogin = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.lastLogin = "";
        r.tCodeLastLogin = "";
      }

      if (r.createdOn) {
        var _ts = dayjs(r.createdOn);
        r.createdOn = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeCreatedOn = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.createdOn = "";
        r.tCodeCreatedOn = "";
      }
    });

    var _list = [...AppHelper.sortList(_res.data, "totalProfiles", 2)];
    setOriginalTutList(_list);

    if (!isIncludeDeletedTut) {
      _res.data = _res.data.filter((x) => x.status == 1);
    }
    _list = [...AppHelper.sortList(_res.data, "totalProfiles", 2)];

    _list = _list.filter((x) => x.accountType == 'TEA' && x.type == "Account");
    setTutList(_list);
    setIsLoading(false);
  };

  // Fetch tutor list for SA tuition center. 
  const fetchAcceptedTutorList = async () => {
    try {
      const response = await AppHelper.apiPost("api/tuition/tutor/list", {
        token: oUser.token,
      });
      if (response && response.status) {
        return response.data;
      } else {
        console.error("Failed to fetch tutors");
        return [];
      }
    } catch (error) {
      console.error("Error fetching tutors:", error);
      return [];
    }
  }

  // Fetch invited tutor list for SA tuition center. 
  const fetchInvitedTutorList = async () => {
    try {
      const response = await AppHelper.apiPost("api/tuiton/invite/list", {
        token: oUser.token,
      });
      if (response && response.status) {
        return response.data;
      } else {
        console.error("Failed to fetch invited tutors. ");
        return [];
      }
    } catch (error) {
      console.error("Error fetching tutors:", error);
      return [];
    }
  }

  const fetchFeedbackList = async () => {
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/feedback/list", {
      token: oUser.token,
      startDate: startDate,
      endDate: endDate,
    });
    if (!_res || !_res.status) {
      return;
    }
    _res.feedbackList.forEach((r, i) => {
      var _ts = dayjs(r.createdOn);
      r.i = i;
      r.createdOn = _ts.format(`DD MMM 'YY HH:mm`);
    });

    var _list = [...AppHelper.sortList(_res.feedbackList, "feedback", 1)];

    setFeedbackList(_list);
    setCountFeedback(_list.length);
    setIsLoading(false);
  };

  useEffect(() => {
    const fetchTotalEssayCount = async () => {
      var _res = await AppHelper.apiPost("api/essay/list/totalCount", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }
      setCountEssay(_res.data);
    }
    fetchTotalEssayCount();

    const fetchTotalExerciseCount = async () => {
      var _res = await AppHelper.apiPost("api/exercise/sentenceTransform/totalCount", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }
      setCountExercise(_res.data);
    }
    fetchTotalExerciseCount();

    const fetchTotalUserCount = async () => {
      var _res = await AppHelper.apiPost("api/account/totalProfileCount", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }
      setCountUser(_res.data);
    }
    fetchTotalUserCount();

    const fetchTotalAccCount = async () => {
      var _res = await AppHelper.apiPost("api/account/list/sa/accCount", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }

      if (!isIncludeDeletedAcc) {
        _res.data = _res.data.filter((x) => x.status == 1);
      }
      setCountAcc(_res.data.length);
    }
    fetchTotalAccCount();

    const fetchTotalTuition = async () => {
      var _res = await AppHelper.apiPost("api/account/totalTuitionCount", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }
      setCountTui(_res.data);
    }
    fetchTotalTuition();
    
    const fetchTotalTutor = async () => {
      var _res = await AppHelper.apiPost("api/account/totalTutorCount", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }
      setCountTut(_res.data);
    }
    fetchTotalTutor();

    const fetchIAM = async () => {
      if (!oUser) {
        navigate("/login");
        return;
      }
      var _res = await AppHelper.apiPost("api/account/iam", {
        token: oUser.token,
      });
      if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
        setIsLoading(false);
        nonSaView();
        return;
      }
    };
    fetchIAM();
    fetchFeedbackList();
  }, [refreshList]);

  const essayViewDone = (arg) => {
    setRefreshList(!refreshList);
    setViewMode("NEW");
  };
  const essayListView = () => {
    navigate("/sa/essay");
  };
  const exerciseListView = () => {
    navigate("/sa/exercise");
  };
  const profileListView = () => {
    fetchProfileList(essayList);
    setViewMode("LIST-PROFILE");
  };
  const accListView = () => {
    fetchAccList();
    setViewMode("LIST-ACC");
  };
  const tuiListView = () => {
    fetchTuiList();
    setViewMode("LIST-TUI");
  };
  const tutListView = () => {
    fetchTutList();
    setViewMode("LIST-TUT");
  };
  const feedbackListView = () => {
    navigate("/sa/feedbacks");
  };

  const popInviteEmailClose = () => {
    setTuiton("");
    setPopInviteEmailOpen(false);
  }
  
  const popReportCardClose = () => {
    setSelectedProfileId("");
	setSelectedProfileName("");
    setIsPopReportCardOpen(false);
  }

  const cardView = () => {
    setIsIncludeDeletedUser(false);
    setViewMode("CARDS");
  };
  const nonSaView = () => {
    setViewMode("NON-SA");
  };
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  const back2Home = () => {
    navigate("/");
  };
  const listSortAndFilterProfile = () => {
    var _list = [...profileList];
    if (filterProfile && filterProfile.length > 0) {
      var _filterText = filterProfile.toLowerCase();
      _list = _list.filter(
        (r) =>
          r.name?.toLowerCase().includes(_filterText) ||
          r.email?.toLowerCase().includes(_filterText) ||
          r.tTitle?.toLowerCase().includes(_filterText) ||
          r.essayCount?.toString().toLowerCase().includes(_filterText)
      );
    }
	
	const finalList = [];
	const profileRows = _list.filter((item) => item.type === 'Profile');
	const _sortedList = stableSortProfile(
		_list,
		getComparator(tblOrderProfile, tblOrderByProfile)
	  );
	
	_sortedList.forEach((row) => {
		finalList.push(row);
		
		profileRows.forEach((profileRow) => {
			if (profileRow.accountId === row.accountId) {
				finalList.push(profileRow);
				}
			});
	});

	return finalList;
  };

  const listSortAndFilterAcc = () => {
    var _list = [...accList];
    if (filterAcc && filterAcc.length > 0) {
      var _filterText = filterAcc.toLowerCase();
      _list = _list.filter((r) => r.email.toLowerCase().includes(_filterText));
    }
    return stableSort(_list, getComparator(tblOrderAcc, tblOrderByAcc));
  };

  const listSortAndFilterTui = () => {
    var _list = [...tuiList];
    if (filterTui && filterTui.length > 0) {
      var _filterText = filterTui.toLowerCase();
      _list = _list.filter((r) => r.email.toLowerCase().includes(_filterText));
    }
    return stableSort(_list, getComparator(tblOrderTui, tblOrderByTui));
  };

  const listSortAndFilterTut = () => {
    var _list = [...tutList];
    if (filterTut && filterTut.length > 0) {
      var _filterText = filterTut.toLowerCase();
      _list = _list.filter((r) => r.email.toLowerCase().includes(_filterText));
    }
	
    return stableSort(_list, getComparator(tblOrderTut, tblOrderByTut));
  };

  const filterProfileChange = (event) => {
    setFilterProfile(event.target.value);
  };
  const filterAccChange = (event) => {
    setFilterAcc(event.target.value);
  };
  const filterTuiChange = (event) => {
    setFilterTui(event.target.value);
  };
  const filterTutChange = (event) => {
    setFilterTut(event.target.value);
  };
  const visibleProfiles = React.useMemo(
    () => listSortAndFilterProfile(),
    [profileList, tblOrderProfile, tblOrderByProfile, filterProfile]
  );
  const visibleAccs = React.useMemo(
    () => listSortAndFilterAcc(),
    [accList, tblOrderAcc, tblOrderByAcc, filterAcc]
  );

  const visibleTuis = React.useMemo(
    () => listSortAndFilterTui(),
    [tuiList, tblOrderTui, tblOrderByTui, filterTui]
  );

  const visibleTuts = React.useMemo(
    () => listSortAndFilterTut(),
    [tutList, tblOrderTut, tblOrderByTut, filterTut]
  );

  const tblSortProfile = (event, property) => {
    const isAsc = tblOrderByProfile === property && tblOrderProfile === "asc";
    setTblOrderProfile(isAsc ? "desc" : "asc");
    setTblOrderByProfile(property);
  };

  const tblSortAcc = (event, property) => {
    const isAsc = tblOrderByAcc === property && tblOrderAcc === "asc";
    setTblOrderAcc(isAsc ? "desc" : "asc");
    setTblOrderByAcc(property);
  };

  const tblSortTui = (event, property) => {
    const isAsc = tblOrderByTui === property && tblOrderTui === "asc";
    setTblOrderTui(isAsc ? "desc" : "asc");
    setTblOrderByTui(property);
  };

  const tblSortTut = (event, property) => {
    const isAsc = tblOrderByTut === property && tblOrderTut === "asc";
	
    setTblOrderTut(isAsc ? "desc" : "asc");
    setTblOrderByTut(property);
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
          <>
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 3,
                width: "100%",
                marginTop: "50px",
              }}
            >
              {viewMode === "CARDS" && (
                <>
                    <React.Fragment>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Typography variant="h3" component="div">
								                {countEssay == null ? <CircularProgress /> : countEssay}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                ESSAYS
                              </Typography>
                              <Typography variant="body2">
                                Total number of submitted essays.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button onClick={essayListView} size="small">
                                More
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
						<Grid item xs={12} sm={4}>
						  <Card variant="outlined">
							<CardContent>
							  <Typography variant="h3" component="div">
								  {countExercise == null ? <CircularProgress /> : countExercise}
							  </Typography>
							  <Typography sx={{ mb: 1.5 }} color="text.secondary">
								EXERCISES
							  </Typography>
							  <Typography variant="body2">
								Total number of submitted exercises.
							  </Typography>
							</CardContent>
							<CardActions>
							  <Button onClick={exerciseListView} size="small">
								More
							  </Button>
							</CardActions>
						  </Card>
						</Grid>
                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Typography variant="h3" component="div">
								                {countUser == null ? <CircularProgress /> : countUser}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                PROFILES
                              </Typography>
                              <Typography variant="body2">
                                Total number of active profiles.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button onClick={profileListView} size="small">
                                More
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Typography variant="h3" component="div">
                                {countAcc == null ? <CircularProgress /> : countAcc}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                ACCOUNTS
                              </Typography>
                              <Typography variant="body2">
                                Total number of active accounts.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button onClick={accListView} size="small">
                                More
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Typography variant="h3" component="div">
                                {countTui == null ? <CircularProgress /> : countTui}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                TUITION CENTERS
                              </Typography>
                              <Typography variant="body2">
                                Total number of active tuition center.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button onClick={tuiListView} size="small">
                                More
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Typography variant="h3" component="div">
                                {countTut == null ? <CircularProgress /> : countTut}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                TUTORS
                              </Typography>
                              <Typography variant="body2">
                                Total number of active tutors.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button onClick={tutListView} size="small">
                                More
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Typography variant="h3" component="div">
                                {countFeedback == null ? <CircularProgress /> : countFeedback}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                                FEEDBACKS
                              </Typography>
                              <Typography variant="body2">
                                Total number of feedbacks. (past 7 days)
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button onClick={feedbackListView} size="small">
                                More
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Card variant="outlined">
                            <CardContent>
                              <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Typography variant="h6" component="div">
                                  Enhanced Transcription
                                </Typography>
                                <Switch
                                  checked={enhancedTransription === 1}
                                  onChange={handleEnhancedTransriptionChange}
                                  inputProps={{ 'aria-label': 'enhanced transcription switch' }}
                                />
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                </>
              )}

              {viewMode == "LIST-PROFILE" && (
                isLoading ? (<AppLoading />) : (
                <>
                  <Grid container>
                    <Grid item xs={3} sm={3}>
                      <Button onClick={cardView}>&laquo; Back to Overview</Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                      {1 == 1 && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={isIncludeDeletedUser}
                              onChange={handleIncludeDeletedUser}
                            />
                          }
                          label="Include Deleted User"
                        />
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        value={filterProfile}
                        onChange={filterProfileChange}
                        id="txtFilterEssay"
                        label=""
                        variant="standard"
                        placeholder="Search"
                        fullWidth
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
				<EnhancedTableHead
                        order={tblOrderProfile}
                        orderBy={tblOrderByProfile}
                        onRequestSort={tblSortProfile}
                        gid="P1"
                        rowCount={profileList.length}
                      />
                      
                      <TableBody>
                        {(() => {
                          let accountCounter = 0; // Initialize the counter for Account rows

                          return visibleProfiles.map((row) => {
                            if (row.type === "Account") {
                              accountCounter += 1; // Increment the counter only for rows with type 'Account'
                            }

                            return (row.type === "Account" || row.isExpanded) && (
                              <React.Fragment key={row.profileId}>
                                <TableRow
                                  sx={{
                                    
                                  }}
                                >
                                  <TableCell align="center">
                                    {row.type === "Account" ? accountCounter : ""}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.type === "Profile" && (
                                      <CircleIcon
                                        style={{
                                          fontSize: 8,
                                          marginLeft: 15,
                                          marginRight: 8,
                                          color: "black",
                                        }}
                                      />
                                    )}
                                    {row.name}
                                  </TableCell>
                                  <TableCell align="left">{row.email}
                                    {/* Show pop usage list */}
                                    {row.type == "Account" &&
                                      <IconButton
                                        onClick={() => handleViewUsageClick(row)}
                                        aria-label="View usage"
                                      >
                                        <VisibilityIcon />
                                      </IconButton>
                                    }
                                  </TableCell>
                                  <TableCell align="right">{row.essayCount}</TableCell>
                                  <TableCell align="left">{row.tTitle}</TableCell>
                                  <TableCell align="left">{row.lTitle}</TableCell>
                                  <TableCell align="left">
                                    {row.type === "Account" && (
                                      <Select
                                        value={row.accountType}
										fullWidth 
                                        onChange={(event) =>
                                          handleAccountTypeChange(event, row.profileId, {useProfileId: true}, row.email)
                                        }
                                        displayEmpty
                                        inputProps={{ "aria-label": "Account Type" }}
                                      >
                                        <MenuItem value="STU">Student</MenuItem>
                                        <MenuItem value="TEA">Tutor</MenuItem>
                                        <MenuItem value="PAR">Parent</MenuItem>
                                        <MenuItem value="TUI">Tuition Center</MenuItem>
                                      </Select>
                                    )}
                                  </TableCell>
                                  <TableCell align="left">
                                    {row.status === 1 && <CheckCircle />}
                                    {row.status === 2 && <Delete />}
                                    {row.status === 0 && <Block />}
                                  </TableCell>
								  
								  <TableCell align="center">
                                     {row.type != "Account" && <IconButton aria-label="report card" onClick={() => handleReportCard(row)} >
										<Leaderboard />
									 </IconButton>
									 }
                                 
                                    {row.type === "Account" && (
                                      <IconButton
                                        onClick={() => toggleCollapse(row)}
                                        aria-label="Expand row"
                                      >
                                        {row.isExpanded ? <ExpandLess /> : <ExpandMore />}
                                      </IconButton>
                                    )}
                                  </TableCell>
                                </TableRow>

                              </React.Fragment>
                            );
                          });
                        })()}
                      </TableBody>

                    </Table>
                  </TableContainer>
                  <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center' }}
                    open={openSnackBar}
                    autoHideDuration={3000}
                    onClose={handleSnackBarClose}
                    message="Account type updated successfully"
                  />
                </>
              )
              )}

              {viewMode == "LIST-ACC" && (
                isLoading ? (<AppLoading />) : (
                <>
                  <Grid container>
                    <Grid item xs={3} sm={3}>
                      <Button onClick={cardView}>&laquo; Back to Overview</Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                      {1 == 1 && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={isIncludeDeletedAcc}
                              onChange={handleIncludeDeletedAcc}
                            />
                          }
                          label="Include Deleted Account"
                        />
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        value={filterAcc}
                        onChange={filterAccChange}
                        id="txtFilterAccount"
                        label=""
                        variant="standard"
                        placeholder="Search"
                        fullWidth
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <EnhancedTableHead
                        order={tblOrderAcc}
                        orderBy={tblOrderByAcc}
                        onRequestSort={tblSortAcc}
                        gid="A1"
                        rowCount={accList.length}
                      />
                      <TableBody>
                        {visibleAccs.map((row, iAcc) => (
                          <TableRow
                            key={row.accountId}
                            sx={{
                            }}
                          >
                            <TableCell align="center">{iAcc + 1}</TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                            <TableCell align="left">
                              <Select
                                value={row.accountType}
										            fullWidth 
                                onChange={(event) =>
                                  handleAccountTypeChange(event, row.accountId, {useProfileId: false}, row.email)
                                }
                                displayEmpty
                                inputProps={{ "aria-label": "Account Type" }}
                              >
                              <MenuItem value="STU">Student</MenuItem>
                              <MenuItem value="TEA">Tutor</MenuItem>
                              <MenuItem value="PAR">Parent</MenuItem>
                              <MenuItem value="TUI">Tuition Center</MenuItem>
                              </Select>
                            </TableCell>

                            <TableCell align="right">
                              {row.totalProfiles}
                            </TableCell>
                            <TableCell align="right">{row.totalEssays}</TableCell>
                            <TableCell align="right">
                              {row.status === 1 && <CheckCircle />}
                              {row.status === 2 && <Delete />}
                              {row.status === 0 && <Block />}
                            </TableCell>
                            <TableCell align="right">{row.createdOn}</TableCell>
                            <TableCell align="right">{row.lastLogin}</TableCell>
                            <TableCell align="right">

                              <IconButton
                                onClick={() => handleViewUsageClick(row)}
                                aria-label="View usage"
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center' }}
                    open={openSnackBar}
                    autoHideDuration={3000}
                    onClose={handleSnackBarClose}
                    message="Profile switched successfully!"
                  />
                </>
                )
              )}


              {viewMode == "LIST-TUI" && (
                isLoading ? (<AppLoading/>) : (
                <>
                  <Grid container>
                    <Grid item xs={3} sm={3}>
                      <Button onClick={cardView}>&laquo; Back to Overview</Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                      {1 == 1 && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={isIncludeDeletedTui}
                              onChange={handleIncludeDeletedTui}
                            />
                          }
                          label="Include Deleted Tuition Center"
                        />
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        value={filterTui}
                        onChange={filterTuiChange}
                        id="txtFilterTuiount"
                        label=""
                        variant="standard"
                        placeholder="Search"
                        fullWidth
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <EnhancedTableHead
                        order={tblOrderTui}
                        orderBy={tblOrderByTui}
                        onRequestSort={tblSortTui}
                        gid="T1"
                        rowCount={tuiList.length}
                      />
                      <TableBody>
                        {(() => {
                          let accountCounter = 0; // Initialize the counter for Account rows

                          return visibleTuis.map((row) => {
                            if (row.accountType === "TUI" && row.type == "Account") {
                              accountCounter += 1; // Increment the counter only for rows with type 'Account'
                            }

                            return ((row.accountType === "TUI"  && row.type == "Account") || (row.isExpanded)) && (
                              <React.Fragment key={row.profileId}>
                                <TableRow
                                  sx={{
                                    
                                  }}
                                >
                                  <TableCell align="center">
                                    {row.accountType === "TUI" && row.type == "Account" ? accountCounter : ""}
                                  </TableCell>
                                  <TableCell align="left">
                                   
                                    {row.name}
                                  </TableCell>
                                  <TableCell align="left">{row.email}</TableCell>
                                
                                  <TableCell align="left">
                                    {row.accountType == "TUI" ? (
                                      row.status === 1 ? <CheckCircle />
                                    : row.status === 2 ? <Delete />
                                    : row.status === 0 ?  <Block /> : '-' 
                                    ) : (
                                      row.accepted ? "ACTIVE" : "INVITED"
                                    )
                                  }
                                  </TableCell>

                                  <TableCell align="left">
                                    {row.accountType == 'TEA' && row.access && row.access.map(((recAcc,iAcc)=>(
                                      <React.Fragment key={'chipAcc'+iAcc}>
                                        { (recAcc.a==1 || recAcc.a==2) &&
                                          <Chip label={recAcc.v} color="secondary" sx={{marginRight:'2px', 
                                            backgroundColor: recAcc.a==1?'#1976d2':'#138275'}} />
                                        }
                                      </React.Fragment>
                                    )))
                                    }
                                    {row.accountType != "TUI" &&
                                      <Tooltip title="access rights">
                                        <IconButton onClick={() => onPopAccessRights(row)}>
                                        <EditIcon style={{color:'#138275'}} />
                                        </IconButton>
                                      </Tooltip>
                                    }
                                </TableCell>
								  
								  <TableCell align="left">{row.createdOn}</TableCell>
                                  <TableCell align="left">{row.lastLogin}</TableCell>
                                
								  
								  <TableCell align="center">
                                     {row.type != "Account" && row.centerId && row.centerId != "" && row.accepted == true && <IconButton aria-label="unlink tutors" onClick={() => handleUnlinkTutor(row)} >
										<LinkOffIcon />
									 </IconButton>
									 }
									 
									  {row.type == "Account" && row.accountType == "TUI" && <IconButton aria-label="link tutor" onClick={() => handleLinkTutor(row)} >
										<LinkIcon />
									 </IconButton>
									 }
                                 
                                    {row.accountType === "TUI" && row.type == "Account" && (
                                      
                                      <IconButton
                                      label="hi"
                                        onClick={() => toggleCollapseTui(row)}
                                        aria-label="Expand row"
                                        style={{fontSize:"15px",
                                          marginBottom: "0px"
                                        }}
                                      >
                                        {row.isExpanded ? <ExpandLess /> : <ExpandMore />}{row.teaCount}
                                      </IconButton>
                                    )}
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            );
                          });
                        })()}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
                )
              )}

              {viewMode == "LIST-TUT" && (
                isLoading ? (<AppLoading/>) : (
                <>
                  <Grid container>
                    <Grid item xs={3} sm={3}>
                      <Button onClick={cardView}>&laquo; Back to Overview</Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                      {1 == 1 && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={isIncludeDeletedTut}
                              onChange={handleIncludeDeletedTut}
                            />
                          }
                          label="Include Deleted Tutor"
                        />
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        value={filterTut}
                        onChange={filterTutChange}
                        id="txtFilterTutount"
                        label=""
                        variant="standard"
                        placeholder="Search"
                        fullWidth
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <EnhancedTableHead
                        order={tblOrderTut}
                        orderBy={tblOrderByTut}
                        onRequestSort={tblSortTut}
                        gid="R1"
                        rowCount={tutList.length}
                      />
                      <TableBody>
                        {visibleTuts.map((row, iTut) => (
                          <TableRow
                            key={row.profileId}
                            sx={{
                            }}
                          >
                            <TableCell align="center">{iTut + 1}</TableCell>
                            <TableCell align="left">{row.name}

                            </TableCell>
                            <TableCell align="left">{row.email}

                            </TableCell>
                            <TableCell align="left">
                              {/* !!! Do not have tuition center name currently, 
                              so have to change later when there is tuition center name added.  */}
                              {row.centerName && row.centerName} 
                              {!row.centerName && "-"}
                            </TableCell>

                            <TableCell align="right">
                              {row.status === 1 && <CheckCircle />}
                              {row.status === 2 && <Delete />}
                              {row.status === 0 && <Block />}
                            </TableCell>
                            <TableCell align="right">{row.createdOn}</TableCell>
                            <TableCell align="right">{row.lastLogin}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
                )
              )}

              {viewMode == "VIEW" && (
                <>
                  <Box>
                    <Button onClick={essayListView}>&laquo; Back to List</Button>
                  </Box>
                  <EssayView
                    essayFormDone={essayViewDone}
                    essayId={recEssay.essayId}
                  ></EssayView>
                </>
              )}
              {viewMode == "NON-SA" && (
                <React.Fragment>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Card variant="outlined">
                        <CardContent>
                          <Typography variant="h5" component="div">
                            Access denied
                          </Typography>
                          <Typography sx={{ mb: 1.5 }} color="text.secondary">
                            &nbsp;
                          </Typography>
                          <Typography variant="body2">
                            This page is only allowed for System Administrators.
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button onClick={back2Home} size="small">
                            Back to Home
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}
            </Box>
          </>
        <SpaCheck></SpaCheck>
      </Box>
      <PopInviteEmail
        open={popInviteEmailOpen} tuiton={tuiton} onClose={popInviteEmailClose}
      />
	  <PopReportCard
        open={isPopReportCardOpen} profileName={selectedProfileName} profileId={selectedProfileId} onClose={popReportCardClose}
      />
      <PopUsageList
        open={isPopUsageOpen}
        accountId={selectedAccount}
        onClose={popUsageListClose}
      ></PopUsageList>
	  
	  <PopLinkTutor
        open={isPopLinkTutorOpen}
        tuiton={tuiton}
		tutors={tutList}
        onClose={popLinkTutorClose}
      ></PopLinkTutor>
      
    <PopAccessRights profile={recProfile}
      open={popAccessRightsOpen} tuiton={tuiton} onClose={popAccessRightsClose}      
    />
    </>
  );
}
